import {debug} from "../utils";

export const ACTION_VIOLATIONS_CHANGED = "ACTION_VIOLATIONS_CHANGED";

export function ViolationsPageReducer(state = {}, action) {
    switch (action.type) {
        case ACTION_VIOLATIONS_CHANGED: {
            debug(`ValidatePageReducer ${ACTION_VIOLATIONS_CHANGED} is being processed...`)
            return {...state, ...action.payload};
        }
        default:
            return state;
    }
}